import { render, staticRenderFns } from "./mydetails.vue?vue&type=template&id=0be3d79a"
import script from "./mydetails.vue?vue&type=script&lang=js"
export * from "./mydetails.vue?vue&type=script&lang=js"
import style0 from "./mydetails.vue?vue&type=style&index=0&id=0be3d79a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports